import { Button } from 'components/Button/Button'
import Heading from 'components/Heading'
import Icon from 'components/Icon/Icon'
import Section, { SectionType, Size } from 'components/Section/Section'
import { UI } from 'Icon/ui'
import * as React from 'react'
import Countdown from 'react-countdown-now'
import Content from './shared/content'
import Page from './shared/page_wrapper'

interface CountdownRenderer {
  hours: number
  minutes: number
  seconds: number
  completed: boolean
}

class GenericError extends React.Component {
  public render() {
    const counterComplete = () => {
      localStorage.setItem(`persist:srprsme_website`, `{}`)
      window.location.reload()
    }

    const countDownRenderer = (data: CountdownRenderer) => {
      return <span>{data.seconds} sec</span>
    }

    return (
      <Page page="error" navFooter>
        <Section type={SectionType.solid} size={Size.s}>
          <div style={{ height: '100vh' }}>
            <Heading
              subHeading={
                <Content contentKey="sub-heading">
                  Oops, there was an error
                </Content>
              }
            >
              <Content contentKey="heading">What now?</Content>
            </Heading>

            <p>
              <Content contentKey="story">
                You did something that caused an error. Our developers have been
                notified and will fix whatever caused this error as soon as
                possible.
              </Content>
            </p>
            <p>
              <Content contentKey="redirect-notification">
                You will be redirected the last viewed page after
              </Content>
              &nbsp;
              <Countdown
                date={Date.now() + 15000}
                renderer={countDownRenderer}
                onComplete={counterComplete}
              />
            </p>
            <br />
            <Button cutOff={'left'} onClick={() => window.open('/', '_self')}>
              <span>
                <Content contentKey="button">Go back to the homepage</Content>
              </span>
              <Icon icon={UI.chevronRight} />
            </Button>
          </div>
        </Section>
        <Section type={SectionType.solid} noPadding={true}>
          {/* This Section is empty on purpose */}
        </Section>
      </Page>
    )
  }
}

export default GenericError
